export default __webpack_public_path__ + "static/media/agentuser.6657e5dd.svg";